import {
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { User } from '../models/classes/user';
import { catchError, tap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { RegionReference } from '../models/classes/region-reference';
import { UserProfileModel } from '../models/classes/user-profile';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserService {
  ip = environment.ipServer;
  errorMessage: string;
  private userUrl = `${this.ip}/api/userlogin`;
  userRef: BehaviorSubject<RegionReference[]>;
  regRef: RegionReference[] = [];

  user: BehaviorSubject<User>;
  selectedUser: User;
  private usrs: BehaviorSubject<User[]>;

  private dataStore: {
    users: User[];
  };

  constructor(private http: HttpClient) {
    this.dataStore = { users: [] };
    this.usrs = new BehaviorSubject<User[]>([]);
    this.user = new BehaviorSubject<User>(null);
    this.userRef = new BehaviorSubject<RegionReference[]>([]);
  }

  getUsers(): Subscription {
    return this.http.get<User[]>(this.userUrl).subscribe((data) => {
      this.dataStore.users = data;
      this.usrs.next(Object.assign({}, this.dataStore).users);
    }, catchError(this.handleError));
  }

  userById(id: number): Subscription {
    const url = `${this.userUrl}/GetUser/${id}`;
    return this.http.get<User>(url).subscribe((data) => {
      this.selectedUser = data;
      this.user.next(Object.assign({}, this.selectedUser));
    }, catchError(this.handleError));
  }

  getUser(id: number) {
    const url = `${this.userUrl}/GetUser/${id}`;
    return this.http.get<User>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  get userId(): Observable<User> {
    return this.user.asObservable();
  }

  get users(): Observable<User[]> {
    return this.usrs.asObservable();
  }

  lockUser(user: User) {
    const url = `${this.userUrl}/${user.id}`;
    return this.http.put(url, user, { observe: 'response' });
  }

  registerUser(user: User): Subscription {
    return this.http.post(this.userUrl, user).subscribe((data) => {});
  }

  getUserRegions(id: number): Subscription {
    const url = `${this.ip}/api/userlogin/GetUserReferences/${id}`;
    return this.http.get<RegionReference[]>(url).subscribe((data) => {
      this.regRef = data;
      this.userRef.next(Object.assign({}, this.regRef));
    }, catchError(this.handleError));
  }

  getIPandPort(): Observable<string> {
    const url = `${this.ip}/api/userlogin/GetHostedIPandPort`;
    return this.http.get(url, { responseType: 'text' });
  }

  sendCredentialNotification(id: number): Observable<any> {
    const url = `${this.ip}/api/email/SendCredentialEmail/${id}`;
    return this.http.get(url);
  }


  Auth(): Observable<Number> {
    const url = `${this.ip}/api/userlogin/GetUserId`;
    return this.http.get<Number>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  defaultPasswordValidate(user: User) {
    const url = `${this.ip}/api/userlogin/defaultPassword`;
    return this.http.post<boolean>(url, user);
  }

  updatePassword(id: number, user: User) {
    const url = `${this.ip}/api/userlogin/UpdatePassword/${id}`;
    return this.http.put(url, user, { observe: 'response' });
  }

  get usrRef(): Observable<RegionReference[]> {
    return this.userRef.asObservable();
  }

  addNewUser(user: User): Observable<any> {
    const url = `${this.ip}/api/userlogin/AddNewUser`;
    return this.http.post(url, user);
  }

  addNewProfile(profile: UserProfileModel) {
    const url = `${this.ip}/api/userlogin/AddNewUserProfile`;
    return this.http.post(url, profile, { observe: 'response' });
  }

  editUserProfile(id: number, profile: UserProfileModel) {
    const url = `${this.userUrl}/UpdateUserProfile/${profile.userId}`;
    return this.http.put(url, profile, { observe: 'response' });
  }

  getUserProfile(id: number) {
    const url = `${this.ip}/api/userlogin/GetUserProfile/${id}`;
    return this.http.get<UserProfileModel>(url);
  }

  getUsermanagementList() {
    const url = `${this.ip}/api/usermanagement`;
    return this.http.get<User[]>(url);
  }

  resetPassword(profile:UserProfileModel){
    const url = `${this.ip}/api/userlogin/restPassword`;
    return this.http.post(url,profile, { observe: 'response' });
  }

  getUserRole(id:number){
    const url = `${this.ip}/api/userlogin/getrole/${id}`;
    return this.http.get(url);
  }
  getMailContent(id: number){
    var userUrl = `${this.ip}/api/email/getqr/${id}`;
    var url = `${userUrl}`;
    return this.http.get(url,{responseType: "text"});
  }

  getrawMailContent(id: number){
    var userUrl = `${this.ip}/api/email/getplainqr/${id}`;
    var url = `${userUrl}`;
    return this.http.get(url,{responseType: "text"});
  }

  updateUserRole(id:number,user:User){
    const url = `${this.userUrl}/UpdateUserRole/${id}`;
    return this.http.put(url, user, { observe: 'response' });
  }

  deletRecord(id:number){
    var userUrl = `${this.ip}/api/userlogin/deleteuser/${id}`;
    return this.http.delete(userUrl, { observe: 'response' });
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
